import { FormDataGroup } from 'src/types';

export const partialDataLeadsCallCenter = (isConfigure?: boolean): Partial<FormDataGroup> => ({
	fields: {
		formFields: {},
		formularioFlag: 'masInformacion',
		formName: isConfigure ? 'lead-call_center-configure' : 'lead-call_center',
		formType: 'contact',
		pageCategory: 'Más Información',
	},
});
